import _slicedToArray from "/home/mibanez/titan-mag/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import { memo as e, useState as t, useEffect as n, createElement as o } from "react";

var r = function r(e) {
  var t = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 5;
  return Number(e.toFixed(t));
},
    l = function l(e) {
  return window.requestAnimationFrame(e);
},
    c = function c(_ref) {
  var e = _ref.backgroundColor,
      c = _ref.height,
      d = _ref.barColor,
      u = _ref.target,
      m = _ref.refTarget;
  var i;

  var _t = t("0%"),
      _t2 = _slicedToArray(_t, 2),
      s = _t2[0],
      a = _t2[1];

  n(function () {
    return i = u ? document.getElementById(u) : null, g(), window.addEventListener("scroll", g), function () {
      return window.removeEventListener("scroll", g);
    };
  }, []);

  var g = function g() {
    var e = m ? m.current : i || null;
    var t = 0,
        n = 0;

    var o = function () {
      var e = 0;
      return document.documentElement && null !== document.documentElement && (e = document.documentElement.scrollTop), window.pageYOffset || e;
    }();

    e ? (t = function (e) {
      var t = e.offsetHeight;
      var n = window.getComputedStyle(e),
          o = n.marginBottom,
          r = n.marginTop;
      return o && r && (t += parseInt(r, 10) + parseInt(o, 10)), t;
    }(e) - document.documentElement.clientHeight, n = e.offsetTop) : t = document.documentElement.scrollHeight - document.documentElement.clientHeight;
    var c = r(o - n);
    if (o < n) return l(function () {
      return a("0%");
    });
    if (c > t) return l(function () {
      return a("100%");
    });
    var d = r(c / t),
        u = "".concat(r(100 * d), "%");
    l(function () {
      return a(u);
    });
  };

  return o("div", {
    style: {
      background: e,
      height: c,
      width: "100vw"
    }
  }, o("div", {
    style: {
      height: c,
      background: d,
      width: s
    }
  }));
};

c.defaultProps = {
  backgroundColor: "#CCC",
  height: "5px",
  barColor: "#e91e63"
};
export default e(c);